export default {
  ANDRAHAND: 'andrahand',
  OVERLATELSE_PRIVATE: 'ov-private',
  OVERLATELSE_COMPANY: 'ov-company'
};
